export default {
  props: {
    config: {},
    model: {}
  },
  data () {
    return {
      form: this.normalizedModel(this.model)
    }
  },
  watch: {
    model (val) {
      this.form = this.normalizedModel(val)
    }
  },
  computed: {
    showAddItem () {
      return this.config.maxItemsCount === 0 || this.config.maxItemsCount > this.form.items.length
    }
  },
  methods: {
    normalizedModel (model) {
      let val = Object.assign({items: []}, model)
      let count = Math.max(this.config.minItemsCount, 1)
      if (val.items.length < count) {
        val.items = val.items.concat(Array(Math.max(count - val.items.length, 1)).fill().map(() => {
          return {}
        }))
      }
      //处理异常数据结构
      val.items = val.items.map(n => {
        return Array.isArray(n) ? {} : n
      })
      return val
    },
    getItems () {
      return this.model.items.filter(n => n.text)
    },
    addItem (index) {
      this.form.items.splice(index + 1, 0, {})
    },
    removeItem (index) {
      if (this.form.items.length > 1 && this.config.minItemsCount < this.form.items.length) {
        this.form.items.splice(index, 1)
      } else {
        this.form.items.splice(index, 1, {})
      }
    },
    handlePasteItems (event, index) {
      let text = event.clipboardData.getData('Text')
      if (/^\s*$/.test(text)) {
        return
      }
      text.split(/\r\n|\n/).forEach((n, i) => {
        let cells = n.split(/\t|\|/)
        this.setPasteText(index + i, 'text', cells[0], i === 0)
        if (this.config.itemsPinyin && cells.length > 1) {
          this.setPasteText(index + i, 'pinyin', cells[1])
        }
      })
    },
    setPasteText(index, attr, text, append) {
      if (text !== null && !/^\s*$/.test(text) && this.form.items.length > index) {
        if (append) {
          document.execCommand('insertText', false, text)
        } else {
          this.$set(this.form.items[index], attr, text)
        }
      }
    }
  }
}
